module.exports = __webpack_public_path__ + "static/video/Uploader.10d5704.swf";


//////////////////
// WEBPACK FOOTER
// ./src/common/plugin/webupload/Uploader.swf
// module id = SXkY
// module chunks = 36